<template>
    <div class="courseVideoPlayer">
        <div class="video" v-show="playType==1">
            <video id="video" :poster="courseData.coverurl" oncontextmenu="return false;" :src="taskInfoData.videoinfojson" ref="video" muted controls
                   @seeked="onSeeked"
                   @seeking="onSeeking"
                   @timeupdate="onTimeupdate"
                   @play="onPlay"
                   @playing="onPlaying"
                   @pause="onPause"
                   @waiting="onPause"
                   @ended="onEnded"
                   @canplay="onCanplayV"
                   @canplaythrough="onCanplaythroughV"
                   @loadedmetadata="onLoadedmetadataV"
                   autoplay
                   controlsList="nodownload"  style="object-fit:fill"
                   x-webkit-airplay="allow" webkit-playsinline playsinline
                   x5-video-player-fullscreen="true" x5-video-player-type="h5-page"
                   x5-video-orientation="landscape|portrait" x5-playsinline>
                <source :src="taskInfoData.videoinfojson">
            </video>
            <div class="marquee" v-if="taskInfoData.ispreventrecording">
                <van-notice-bar
                    scrollable
                    ref="vanNoticeBar"
                    :text="user.nickname + ':' + user.innerid"
                    background="transparent"
                />
            </div>
        </div>
        <div class="audio" v-show="playType == 2">
            <div class="progress-wrapper">
                <i
                    class="icon"
                    @click="handlePlayClick"
                    :class="[
                        progressBar.playing
                            ? 'icon-course-pause'
                            : 'icon-course-play',
                    ]"
                ></i>
                <span class="time time-l">{{
                    param.currentstudytimes | format
                }}</span>
                <div
                    class="progress-bar"
                    ref="progressBar"
                    @click="progressClick"
                >
                    <div class="bar-inner">
                        <div class="progress" ref="progress"></div>
                        <div
                            class="progress-btn-wrapper"
                            ref="progressBtn"
                            @touchstart.prevent="progressTouchStart"
                            @touchmove.prevent="progressTouchMove"
                            @touchend="progressTouchEnd"
                        >
                            <div class="progress-btn"></div>
                        </div>
                    </div>
                </div>
                <span class="time time-r">{{
                    taskInfoData.totalduration | format
                }}</span>
            </div>
        </div>
        <audio
            ref="audio"
            :src="taskInfoData.videoinfojson"
            @timeupdate="onTimeupdate"
            @loadedmetadata="onLoadedmetadataA"
            @canplay="onCanplayA"
            @pause="onPauseA"
            @ended="onEnded"
            @play="onPlay"
        ></audio>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { pushLearnRecord } from "api/api";
import $ from "jquery";
import Hls from "hls.js"
export default {
    name: "courseVideoPlayer",
    props: ["courseData"],
    data() {
        return {
            taskInfoData: {
                taskid: "",
            },
            timer: {
                timer: null,
                num: 0,
                time: 5,
                flag: false,
            },
            param: {
                taskid: "", // 任务id
                courseid: this.$route.query.cid,
                isfinishstudy: 0, // 是否完成学习
                time: 0, // 两次提交接口时间间隔
                currentstudytimes: 0, // 当前学习位置
                maxstudytimes: 0, // 最大学习位置
            },
            av: null, // 视频播放器
            aa: null, // 音频播放器
            initV: 0, // 视频初始化 0 未初始化 1 loadedmeta 2 canplay
            initA: 0, // 音频初始化
            touchType: 0, // 1 touchenter 2 touchstart 3 touchmove 4 touchend  5 touchleave
            percent: 0,
            touch: {
                initiated: false,
                startX: 0,
                left: 0,
            },
            progressBar: {
                playing: false, // 播放状态
                barWidth: 200, // 进度条长度
                progressBtnWidth: 8, // 进度按钮宽度
                progressWidth: 0, // 已播进度长度
            },
            playType: 1, // 播放类型 1 视频 2 音频
        };
    },
    mounted() {
        document.addEventListener("visibilitychange", this.onVisibilitychange);
    },
    methods: {
        setFullScreen() {
            this.av.play();
            setTimeout(() => {
                if (this.av.requestFullScreen) {
                    this.av.requestFullScreen();
                } else if (this.av.msRequestFullscreen) {
                    // ie
                    this.av.msRequestFullscreen();
                } else if (this.av.requestFullscreen) {
                    // W3C
                    this.av.requestFullscreen();
                } else if (this.av.mozRequestFullScreen) {
                    // FireFox
                    this.av.mozRequestFullScreen();
                } else if (this.av.webkitRequestFullScreen) {
                    // Chrome等
                    this.av.webkitRequestFullScreen();
                } else if (this.av.webkitEnterFullScreen) {
                    this.av.webkitEnterFullScreen();
                }
            }, 50);
        },
        exitFullScrren() {
            if (this.av.cancelFullScrren) {
                this.av.cancelFullScrren();
            } else if (this.av.msExitFullscreen) {
                this.av.msExitFullscreen();
            } else if (this.av.mozCancelFullScreen) {
                this.av.mozCancelFullScreen();
            } else if (this.av.webkitCancelFullScreen) {
                this.av.webkitCancelFullScreen();
            } else if (this.av.webkitExitFullScreen) {
                this.av.webkitExitFullScreen();
                // document.exitFullscreen()  // 浏览器
            } else if (this.av.exitFullscreen) {
                this.av.exitFullscreen();
            }
        },
        checkFullScrren() {
            var isFull =
                this.av.fullscreenEnabled ||
                this.av.fullScreen ||
                this.av.webkitIsFullScreen ||
                this.av.msFullscreenEnabled;
            if (isFull === undefined) isFull = false;
            return isFull;
        },
        setPlayType(playType) {
            this.playType = playType;
            if (playType === 2) {
                this.$nextTick(() => {
                    this.progressBar.barWidth =
                        this.$refs.progressBar.clientWidth;
                    this.progressBar.progressBtnWidth =
                        this.$refs.progressBtn.clientWidth / 2;
                    const offsetWidth =
                        (this.progressBar.barWidth *
                            this.param.currentstudytimes) /
                        this.taskInfoData.totalduration;
                    this.aa.currentTime = this.param.currentstudytimes;
                    this.progressBar.progressWidth = offsetWidth;
                    this.$refs.progress.style.width = `${offsetWidth}px`;
                    this.$refs.progressBtn.style.transform = `translate3d(${offsetWidth}px,0,0)`;
                    this.aa.playbackRate = this.av.playbackRate;
                    if (!this.av.paused) {
                        this.av.pause();
                        this.progressBar.playing = true;
                        this.aa.play();
                    }
                });
            } else if (playType === 1) {
                this.av.playbackRate = this.aa.playbackRate;
                this.av.currentTime = this.param.currentstudytimes;
                if (this.progressBar.playing) {
                    this.progressBar.playing = false;
                    this.aa.pause();
                    this.av.play();
                }
            }
        },
        handlePlayClick() {
            this.progressBar.playing = !this.progressBar.playing;
            if (this.progressBar.playing) {
                this.timer.flag = true;
                this.aa.play();
            } else {
                this.timer.flag = false;
                this.aa.pause();
            }
        },
        progressClick(e) {
            const rect = this.$refs.progressBar.getBoundingClientRect();
            const offsetWidth = e.pageX - rect.left;
            this._offset(offsetWidth);
        },
        progressTouchStart(e) {
            this.aa.pause();
            this.touch.initiated = true;
            this.touch.startX = e.touches[0].pageX;
            this.touch.left = this.$refs.progress.clientWidth;
        },
        progressTouchMove(e) {
            if (!this.touch.initiated) {
                return;
            }
            const deltaX = e.touches[0].pageX - this.touch.startX;
            const offsetWidth = Math.min(
                this.progressBar.barWidth - this.progressBar.progressBtnWidth,
                Math.max(0, this.touch.left + deltaX)
            );
            this._offset(offsetWidth);
        },
        progressTouchEnd() {
            this.touch.initiated = false;
            const currentTime =
                this.taskInfoData.totalduration * this._getPercent();
            if (
                !this.taskInfoData.isfinishstudy &&
                !this.taskInfoData.isspeedplay &&
                currentTime > this.param.maxstudytimes
            ) {
                this.$toast.fail("课程未完成学习，不能快进");
                this._offset(this.progressBar.progressWidth);
            } else {
                this.progressBar.progressWidth =
                    this.$refs.progress.clientWidth;
                this._progressBarChange(currentTime);
            }
            this.aa.play();
        },
        _offset(offsetWidth) {
            this.$refs.progress.style.width = `${offsetWidth}px`;
            this.$refs.progressBtn.style.transform = `translate3d(${offsetWidth}px,0,0)`;
        },
        _getPercent() {
            const barWidth =
                this.progressBar.barWidth - this.progressBar.progressBtnWidth;
            return this.$refs.progress.clientWidth / barWidth;
        },
        _progressBarChange(currentTime) {
            this.param.currentstudytimes = this.aa.currentTime = currentTime;
            this.aa.play();
        },
        setPlaySpeed(speed) {
            if (this.playType === 1) {
                this.av.playbackRate = speed;
            } else {
                this.aa.playbackRate = speed;
            }
        },
        onPlay() {
            if (this.playType==1) {
                this.$refs.video.muted = false
            }
            // console.log('Playing')
            this.timer.flag = true;
            if (!this.timer.timer) {
                this.timer.num = 0;
                this._initTimer();
            }
        },
        onPlaying() {
            this.timer.flag = true;
        },
        onPause() {
            this.timer.flag = false;
        },
        onPauseA() {
            let _this = this;
            setTimeout(() => {
                if (_this.progressBar.playing) {
                    _this.aa.play();
                }
            }, 30);
        },
        onEnded() {
            this.timer.flag = false;
            clearInterval(this.timer.timer);
            this.timer.timer = null;
            this.param.time = this.timer.num;
            this.param.isfinishstudy = 1;
            this._pushLearnRecord();
            this.param.currentstudytimes = 0;
            this.param.isfinishstudy = 0;
            this.progressBar.playing = false;
            if (this.checkFullScrren) this.exitFullScrren();
        },
        onSeeked(e) {
            if (
                this.touchType &&
                e.target.currentTime - this.param.maxstudytimes > 1
            ) {
                this.$toast.fail("课程未完成学习，不能快进");
                this.av.currentTime = this.param.maxstudytimes;
            }
            this.touchType = 0;
        },
        onSeeking() {
            if (
                !this.taskInfoData.isfinishstudy &&
                !this.taskInfoData.isspeedplay
            ) {
                this.touchType = 2;
            }
        },
        onTimeupdate(e) {
            // console.log(e)
            if (
                (!this.touchType && this.initV === 2 && this.playType === 1) ||
                (this.initA === 2 && this.playType === 2)
            ) {
                this.param.currentstudytimes = e.target.currentTime;
                if (this.param.currentstudytimes > this.param.maxstudytimes) {
                    this.param.maxstudytimes = this.param.currentstudytimes;
                }
            }
        },
        onCanplaythroughV() {
            this.timer.flag = true
            // this.av.muted = true
            this.av.play()
            this.av.muted = false
        },
        onCanplayV() {
            // console.log("onCanplayV 1 ", this.param.currentstudytimes);
            if (this.initV === 1) {
                  this.av.currentTime = this.param.currentstudytimes
                // this.av.currentTime = 10;
                // console.log("onCanplayV 2 ", this.param.currentstudytimes);
                // console.log("onCanplayV 2 ", this.av.currentTime);
                this.initV = 2;
                // this.av.muted = true
                this.av.play()
                this.av.muted = false
            }
        },
        onCanplayA() {
            // console.log("onCanplayA 2 ", this.av.currentTime);
            if (this.initA === 1) {
                // console.log("onCanplayA 2 ", this.av.currentTime);
                this.aa.currentTime = this.param.currentstudytimes;
                // console.log("onCanplayA 2 ", this.av.currentTime);
                this.initA = 2;
            }
        },
        onLoadedmetadataV() {
            this.initV = 1;
            // this.av.currentTime = 10;
            // console.log("onLoadedmetadataV ", this.av.currentTime);
            // console.log("onLoadedmetadataV ", this.av.currentTime);
        },
        onLoadedmetadataA() {
            this.initA = 1;
        },
        onVisibilitychange() {
            if (this.playType === 1) {
                if (document.hidden) {
                    this.onPause();
                } else {
                    this.onPlaying();
                }
            }
        },
        getVideo(taskInfoData) {
            if (this.taskInfoData.taskid !== taskInfoData.taskid) {
                this.playType = 1;
                this.taskInfoData = taskInfoData;
                // console.log("getVideo ", this.pataskInfoData);

                this.initV = 0;
                this.initA = 0;
                this._initParam();
                this.$nextTick(() => {
                    this.av = this.$refs.video;
                    this.aa = this.$refs.audio;
                    if (this.taskInfoData.videoinfojson.indexOf('.m3u8') > -1) {
                        if (Hls.isSupported()) {
                            var hls = new Hls()
                            hls.loadSource(this.taskInfoData.videoinfojson)
                            hls.attachMedia(this.av)
                        }
                    }
                    this.av.muted = false
                    if (this.timer.timer) clearInterval(this.timer.timer);
                    if (this.progressBar.playing) {
                        this.progressBar.playing = false;
                        if (this.aa) this.aa.pause();
                    }
                    this._initTimer();
                });
            }
        },
        _initParam() {
            this.param.taskid = this.taskInfoData.taskid;
            this.param.time = this.timer.time;
            this.param.isfinishstudy = 0;
            if (
                this.taskInfoData.totalduration > 0 &&
                this.taskInfoData.currentstudytimes >=
                    this.taskInfoData.totalduration
            ) {
                this.param.currentstudytimes = 0;
            } else {
                this.param.currentstudytimes =
                    this.taskInfoData.currentstudytimes | 0;
            }
            // console.log("_initParam ", this.param.currentstudytimes);
            this.param.maxstudytimes = this.taskInfoData.maxstudytimes | 0;
            this.timer.num = 0;
            this.timer.flag = false;
        },
        _initTimer() {
            const _this = this;
            this.timer.timer = setInterval(() => {
                if (_this.timer.flag) {
                    _this.timer.num++;
                    if (_this.timer.num % _this.timer.time === 0) {
                        _this._pushLearnRecord();
                        _this.timer.num = 0;
                    }
                }
            }, 1000);
        },
        _pushLearnRecord() {
            if (!this.progressBar.playing) {
                return
            }
            let param = $.extend(true, {}, this.param);
            param.currentstudytimes = parseInt(this.param.currentstudytimes);
            pushLearnRecord({
                data: param,
                success: () => {},
                error: () => {},
            });
        },
        ...mapActions(["setLoading"]),
    },
    filters: {
        format(interval) {
            interval = interval | 0;
            const hour = parseInt(interval / 60 / 60);
            const minute = _pad(parseInt(interval / 60) - hour * 60);
            const second = _pad(interval % 60);
            return `${minute}:${second}`;
            function _pad(num, n = 2) {
                let len = num.toString().length;
                while (len < n) {
                    num = "0" + num;
                    len++;
                }
                return num;
            }
        },
    },
    watch: {
        "param.currentstudytimes": {
            handler(val) {
                if (this.playType === 2) {
                    const barWidth =
                        this.progressBar.barWidth -
                        this.progressBar.progressBtnWidth;
                    const offsetWidth =
                        (val / this.taskInfoData.totalduration) * barWidth;
                    this.$refs.progress.style.width = `${offsetWidth}px`;
                    this.$refs.progressBtn.style.transform = `translate3d(${offsetWidth}px,0,0)`;
                }
            },
        },
    },
    computed: {
        ...mapGetters(["user"]),
    },
    beforeDestroy() {
        clearInterval(this.timer.timer);
        // document.removeEventListener('visibilitychange', () => {
        //   this.onVisibilitychange()
        // })
    },
    components: {},
};
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.courseVideoPlayer {
    width: 7.5rem;
    height: 4.22rem;
    .video {
        position: relative;
    }
    video {
        vertical-align: middle;
        width: 100%;
        height: 4.22rem;
        object-fit: fill;
    }
    video::-webkit-media-controls-fullscreen-button {
        display: none;
    }
    .marquee {
        position: absolute;
        top: 1rem;
        left: 0;
        right: 0;
        font-size: 0.36rem;
        white-space: nowrap;
        overflow: hidden;
        z-index: 10000;
        .van-notice-bar,
        .van-notice-bar__wrap {
            padding: 0.12rem;
        }
        .van-notice-bar__content {
            padding-left: 7.5rem !important;
            color: #ec5e69 !important;
        }
    }
    .audio {
        position: absolute;
        bottom: 0.32rem;
        left: 0.32rem;
        right: 0.32rem;
        .progress-wrapper {
            width: 100%;
            height: 0.82rem;
            background: rgba(255, 255, 255, 0.9);
            box-shadow: 0 0 0.06rem 0 rgba(0, 0, 0, 0.3);
            border-radius: 0.1rem;
            box-sizing: border-box;
            padding: 0 0.2rem;
            display: flex;
            align-items: center;
            .icon {
                &:before {
                    width: 0.62rem;
                    min-width: 0.62rem;
                    height: 0.62rem;
                    margin-right: 0.12rem;
                }
            }
            .time {
                color: #909399;
                font-size: 0.22rem;
                width: 0.7rem;
            }
            .time-l {
                text-align: right;
            }
            .time-r {
                text-align: left;
            }
            .progress-bar {
                height: 0.3rem;
                width: 4rem;
                margin: 0 0.12rem;
                .bar-inner {
                    position: relative;
                    top: 0.13rem;
                    height: 0.08rem;
                    background: #e5e5e5;
                    border-radius: 0.09rem;
                    .progress {
                        position: absolute;
                        height: 100%;
                        background: #409eff;
                        border-radius: 0.09rem 0 0 0.09rem;
                    }
                    .progress-btn-wrapper {
                        position: absolute;
                        left: -0.08rem;
                        top: -0.13rem;
                        width: 0.3rem;
                        height: 0.3rem;
                    }
                    .progress-btn {
                        position: relative;
                        top: 0.08rem;
                        left: 0.07rem;
                        box-sizing: border-box;
                        width: 0.16rem;
                        height: 0.16rem;
                        box-shadow: 0 0 0.04rem 0 rgba(0, 0, 0, 0.3);
                        border-radius: 50%;
                        background: #ffffff;
                    }
                }
            }
        }
    }
}
</style>